import React, { useState, useEffect, useRef } from 'react';
import './OptOutContactsReport.scss'; // Reusing the same scss file as requested
import LoadingIndicator from '@/components/loader';
import * as XLSX from 'xlsx-js-style';
import { getContactOptoutLogs } from '@/services/contactOptout';

const OptOutContactsReport = () => {
    const [loading, setLoading] = useState(true);
    const [reportHtml, setReportHtml] = useState("");
    const reportContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const fetchReport = async () => {
            try {
                const response = await getContactOptoutLogs();
                setReportHtml(response.data);
            } catch (error) {
                console.error("Error fetching contact opt out report:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchReport();
    }, []);

    useEffect(() => {
        if (reportContainerRef.current) {
            const headers = reportContainerRef.current.querySelectorAll('th');
            headers.forEach(header => {
                header.innerHTML = `<b>${header.innerHTML}</b>`;
            });
        }
    }, [reportHtml]);

    const exportToXLS = () => {
        if (reportContainerRef.current) {
            const table = reportContainerRef.current.querySelector('table');
            if (table) {
                const ws = XLSX.utils.table_to_sheet(table);

                // Set column widths
                ws['!cols'] = [
                    { wch: 40 },
                    { wch: 60 },
                    { wch: 40 },
                ];

                // Iterate over table rows and cells to apply bold style
                const rows = table.getElementsByTagName('tr');
                for (let i = 0; i < rows.length; i++) {
                    const cells = rows[i].querySelectorAll('td, th');
                    for (let j = 0; j < cells.length; j++) {
                        const cell = cells[j];
                        if (cell.getElementsByTagName('b').length > 0) {
                            const address = XLSX.utils.encode_cell({ r: i, c: j });
                            if (ws[address]) {
                                ws[address].s = { font: { bold: true } };
                            }
                        }
                    }
                }

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Contact Optout Report');
                XLSX.writeFile(wb, 'Contact-Optout-Report.xlsx');
            }
        }
    };

    return (
        <div className='opt-out-logs-container'>
            <LoadingIndicator inProgress={loading} />
            {!loading && (
                <>
                    <button className="opt-out-logs-export-button" type="button" onClick={exportToXLS}>Export to Excel</button>
                    <hr />
                    <div ref={reportContainerRef} dangerouslySetInnerHTML={{ __html: reportHtml }} />
                </>
            )}
        </div>
    );
};

export default OptOutContactsReport;
